import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    params: {
        page: 1,
        per_page: 30,
        q: {
            status: "",
            name: "",
            tel: "",
            start_at: "",
            end_at: ""
        }
    }
}

const mutations = {
    changeUserCouponsPage(state, val) {
        state.params = val
    }
}

export default {
    state,
    mutations
}